import { getCurrentUserAPI } from "api";
import _ from "lodash";
import React, { useEffect } from "react";
import { FaCropAlt, FaTag } from "react-icons/fa";
import styled from "styled-components";
import { useMainContext } from "contexts"
import { useModal } from "hooks";
import { ReportJIRAIssue } from "modals";
import { Link } from "@reach/router";
import { FiPackage } from "react-icons/fi";
import { navigate } from "@reach/router";

export const Footer = () => {
  const { liveCounterData, setLiveCounterData } = useMainContext();
  const viewReportIssueModal = useModal();

  useEffect(() => {
    handleLiveData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handleLiveData = async () => {
    const res = await getCurrentUserAPI();
    if (res.success) {
      setLiveCounterData(res.results);
    }
  }
  return (
    <Container>
      <ReportJIRAIssue
        {...viewReportIssueModal}
      />
      <FooterContent>
        <LeftFooter>
          <BrandText to="/">ADDISON</BrandText>
          <FooterLink
            onClick={viewReportIssueModal.openModal}
          >
            Raise an Issue
          </FooterLink>
          <FooterLink onClick={() => navigate('/block-search')}>
            Block Search
          </FooterLink>
        </LeftFooter>
        {!_.isEmpty(liveCounterData) &&
          <LiveCounter>
            <CounterLabel>
              <FaCropAlt size={14} /> {liveCounterData.cropping_completed ? liveCounterData.cropping_completed : 0}
            </CounterLabel>
            <CounterDivider />
            <CounterItem>
              <CounterLabel>CM {liveCounterData.cm_block ? liveCounterData.cm_block : 0}</CounterLabel>
            </CounterItem>
            <CounterDivider />
            <CounterItem>
              <CounterLabel>IM</CounterLabel>
              <CounterLabel><FiPackage size={14} /> {liveCounterData.im_product ? liveCounterData.im_product : 0}</CounterLabel>
              <CounterLabel><FaTag size={12} /> {liveCounterData.im_offer ? liveCounterData.im_offer : 0}</CounterLabel>
            </CounterItem>
            <CounterDivider />
            <CounterItem>
              <CounterLabel>EM</CounterLabel>
              <CounterLabel><FiPackage size={14} /> {liveCounterData.em_product ? liveCounterData.em_product : 0}</CounterLabel>
              <CounterLabel><FaTag /> {liveCounterData.em_offer ? liveCounterData.em_offer : 0}</CounterLabel>
            </CounterItem>
            <CounterDivider />
            {/* <CounterItem>
              <CounterLabel>TTB</CounterLabel>
              <CounterLabel><FiPackage size={14} /> {liveCounterData.ttb_product_completed ? liveCounterData.ttb_product_completed : 0}</CounterLabel>
              <CounterLabel><FaTag size={12} /> {liveCounterData.ttb_offer_completed ? liveCounterData.ttb_offer_completed : 0}</CounterLabel>
            </CounterItem>
            <CounterDivider /> */}
            <CounterItem>
              <CounterLabel>ENTRY</CounterLabel>
              <CounterLabel><FiPackage size={14} /> {liveCounterData.ltr_product_completed ? liveCounterData.ltr_product_completed : 0}</CounterLabel>
              <CounterLabel><FaTag size={12} /> {liveCounterData.ltr_offer_completed ? liveCounterData.ltr_offer_completed : 0}</CounterLabel>
            </CounterItem>
          </LiveCounter>
        }
      </FooterContent>
    </Container>
  );
};

const Container = styled.div`
  background: ${(props) => props.theme.palette?.backgrounds || '#131313'};
  height: 50px;
  color: white;
  font-size: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 900;
`;

const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 24px;
  margin: 0 auto;
  height: 100%;
`;

const LeftFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const BrandText = styled(Link)`
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.5px;
  color: rgba(255, 255, 255, 0.6);
  &:hover {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
  }
`;

const FooterLink = styled.div`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
  padding: 5px 8px;
  border-radius: 4px;
  
  &:hover {
    color: rgba(255, 255, 255, 0.9);
    background: rgba(255, 255, 255, 0.05);
  }
`;

const LiveCounter = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 100%;
`;

const CounterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 6px;
  height: 32px;
`;

const CounterLabel = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  margin-right: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
  :svg {
    color: rgba(255, 255, 255, 0.7);
  }
`;

const CounterDivider = styled.div`
  height: 40%;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.05);
`;

const CounterRefreshButton = styled.button`
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
  
  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
    color: white;
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0 0 8px rgba(255, 255, 255, 0.2);
  }
`;